type FaqItemLike<TChild> = {
  question: string;
  answer: string;
  children?: TChild[];
};

const isEmpty = (item: { question: string; answer: string }): boolean =>
  item.question.trim().length === 0 && item.answer.trim().length === 0;

export const filterEmptyFaqItems = <
  TChild extends FaqItemLike<TChild>,
  TItem extends FaqItemLike<TChild>,
>(
  items: TItem[],
): TItem[] =>
  items.reduce<TItem[]>((kept, item) => {
    if (isEmpty(item)) return kept;
    const filteredChildren = item.children?.filter((child) => !isEmpty(child));

    kept.push({
      ...item,
      ...(filteredChildren && filteredChildren.length > 0
        ? { children: filteredChildren }
        : { children: undefined }),
    });

    return kept;
  }, []);
